// Imports
import React from 'react';
import PageTitle from '../shared-components/page-title';
import LeadingText from '../shared-components/leading-text';


// Function component
const NotFound = () => {
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle appendCommunityName={false} documentTitle='Page not found'>
				Page not found (404)
			</PageTitle>
			<LeadingText>We weren’t able to find that page. Try using the menu links to get back on track.</LeadingText>
		</React.Fragment>
	);
};

export default NotFound;
